import gql from "graphql-tag";

export const entityCommentFragment = gql`
  fragment EntityCommentFragment on EntityComment {
    id
    entityType
    entityId
    message
    userId
    createdAt
    updatedAt
    isAuthor
    user {
      id
      firstName
      lastName
      avatarUrl
    }
  }
`;
